export default __webpack_public_path__ + "static/media/eleven.cb4f56a4.png";